export const NAME = 'ChecklistComponent';
export const ERROR = {
  ITEMS_FORMAT: 'Checklist Model: items must be an array of strings!',
  MISSING_OPTION: 'Checklist Model: Missing required option',
};

export default {
  NAME,
};
